import * as firebase from "firebase";
import Settings from "../base/Settings"

let firebaseConfig = {
  apiKey: Settings.API_KEY,
  authDomain: Settings.AUTH_DOMAIN,
  databaseURL: Settings.DATABASE_URL,
  projectId: Settings.PRODUCT_ID,
  storageBucket: Settings.STORAGE_BUCKET,
  messagingSenderId: Settings.MESSAGING_SENDER_ID
  // ,appId: "1:638458887693:web:960d7e9a5aa32384a61f44",
  // measurementId: "G-PSS5J6Q02B"
};

export const firebaseApp = firebase.initializeApp(firebaseConfig);



// WEBPACK FOOTER //
// ./src/provider/config/Firebase.js